document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".size-guide-wrapper");
  if (!wrapper) return;

  // Tab Toggle (Measurement / Conversion)
  wrapper.querySelectorAll(".size-tab-toggle button").forEach(btn => {
    btn.addEventListener("click", function() {
      const selected = this.dataset.tab;
      wrapper.querySelectorAll(".size-tab-toggle button").forEach(b => b.classList.remove("active"));
      this.classList.add("active");
      wrapper.querySelectorAll(".size-table-wrapper").forEach(div => {
        div.hidden = div.dataset.tab !== selected;
      });
    });
  });

  // Unit Toggle (IN / CM)
  wrapper.querySelectorAll(".size-unit-toggle").forEach(toggle => {
    const buttons = toggle.querySelectorAll("button");
    buttons.forEach(btn => {
      btn.addEventListener("click", function() {
        const unit = this.dataset.unit;
        buttons.forEach(b => b.classList.remove("actived"));
        this.classList.add("actived");
        const table = toggle.nextElementSibling;
        if (!table) return;
        table.querySelectorAll("span[data-unit]").forEach(span => {
          span.hidden = span.dataset.unit !== unit;
        });
      });
    });
  });

  document.querySelectorAll(".size-table--scroller").forEach(table => {
    const cols = table.querySelectorAll("tr:first-child th").length;
    table.style.setProperty("--col-count", cols);
    if (cols > 5) {
      table.classList.add("scroll-4-5");
    }
  });

  // Geolocation Default: switch to CM if not US
  const prefersMetric = () => {
    const country = window.Shopify?.country || document.documentElement.getAttribute('data-country');
    return country && country !== 'US';
  };
  if (prefersMetric()) {
    wrapper.querySelectorAll(".size-unit-toggle").forEach(toggle => {
      const cmBtn = toggle.querySelector('[data-unit="metric"]');
      if (cmBtn) cmBtn.click();
    });
  } 
});